module.exports = __webpack_public_path__ + "static/media/Donkey-web-logo.ffb8ee79.png";